var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseIconSmall = function SvgCloseIconSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1892_28153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3226 11.9796L20.7836 4.53856C20.931 4.36685 21.0081 4.14597 20.9993 3.92007C20.9906 3.69416 20.8967 3.47987 20.7364 3.32002C20.5761 3.16016 20.3612 3.06651 20.1347 3.05779C19.9082 3.04906 19.6868 3.1259 19.5146 3.27295L12.0536 10.714L4.59259 3.26397C4.42312 3.09495 4.19326 3 3.95359 3C3.71392 3 3.48406 3.09495 3.31459 3.26397C3.14512 3.43299 3.04991 3.66224 3.04991 3.90127C3.04991 4.1403 3.14512 4.36954 3.31459 4.53856L10.7846 11.9796L3.31459 19.4206C3.22038 19.5011 3.14386 19.6001 3.08984 19.7115C3.03582 19.8229 3.00546 19.9441 3.00067 20.0678C2.99588 20.1914 3.01677 20.3146 3.06202 20.4298C3.10726 20.545 3.17589 20.6496 3.2636 20.7371C3.35131 20.8246 3.45621 20.893 3.5717 20.9382C3.68719 20.9833 3.81079 21.0041 3.93474 20.9993C4.05868 20.9946 4.1803 20.9643 4.29196 20.9104C4.40362 20.8565 4.50291 20.7802 4.58359 20.6863L12.0536 13.2452L19.5146 20.6863C19.6868 20.8333 19.9082 20.9101 20.1347 20.9014C20.3612 20.8927 20.5761 20.799 20.7364 20.6392C20.8967 20.4793 20.9906 20.265 20.9993 20.0391C21.0081 19.8132 20.931 19.5924 20.7836 19.4206L13.3226 11.9796Z",
    fill: "#404249"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1892_28153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIconSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CloseIconSmall.d7d652a6.svg";
export { ForwardRef as ReactComponent };